import React, { Component } from "react";
import { Button, Card, Form } from "semantic-ui-react";

class ApplicationForm extends Component {
  state = {
    input: {
      name: "",
    }
  };
  handleChange = (event, { name, value }) => {
    this.setState(state => {
      return { input: { ...state.input, [name]: value } };
    });
  };
  handleSubmit = () => {
    this.props.submit(this.state.input).then(this.props.hide);
  };
  handleCancel = event => {
    event.preventDefault();
    this.props.hide();
  };

  render() {
    return (
      <Card>
        <div style={{ padding: "1rem 2rem" }}>
          <Form onSubmit={this.handleSubmit}>
            <Form.Input
              label="Application Name"
              name="name"
              id="name-input"
              value={this.state.input.name}
              onChange={this.handleChange}
            />
            <Button primary type="submit" loading={this.props.loading}>
              Create Application
            </Button>
            <Button onClick={this.handleCancel}>Cancel</Button>
          </Form>
        </div>
      </Card>
    );
  }
}

export default ApplicationForm;


// WEBPACK FOOTER //
// ./src/pages/Applications/ApplicationForm.js